export default "__VITE_ASSET__C7iSMn1u__"